module.exports = __webpack_public_path__ + "img/no-preview-mobile.af305222.png";